import React from "react";

export const Separator = () => <div className="h-[1px] bg-input" />;
